import React, {Component} from 'react'
import { HeaderActionsComponent } from './HeaderActions.component'

class HeaderActionsContainer extends Component {
  isEmpty = (obj) => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false
      }
    }
    return true
  }

  render() {
    const { filterDrawerOpen, analytics, multiselect, i18n, handleExportOpenClick, handleFilterOpenClick, handleSearchOpenClick, children, api, download, headerButtons, env, selectedRows } = this.props

    const filterCount = !this.isEmpty(api.filters) ? api.customFilter === null ? api.getFiltersAsList().length : 1 : 0

    return (
      <HeaderActionsComponent
        filterDrawerOpen={filterDrawerOpen}
        analytics={analytics}
        multiselect={multiselect}
        selectedRows={selectedRows}
        api={api}
        env={env}
        headerButtons={headerButtons}
        download={download}
        i18n={i18n}
        handleSearchOpenClick={handleSearchOpenClick}
        handleExportOpenClick={handleExportOpenClick}
        handleFilterOpenClick={handleFilterOpenClick}
        children={children}
        filterCount={filterCount}
      />
    )
  }
}

export default HeaderActionsContainer
